//Automatically generate article directory index
  document.addEventListener("DOMContentLoaded", function () {
    const content = document.querySelector(".article-content .prose");
    const tocContainer = document.getElementById("article-toc");

    if (!content || !tocContainer) return;

    const headings = content.querySelectorAll("h1,h2");
    if (!headings.length) return;

    const tocList = document.createElement("ul");
    tocList.classList.add("space-y-2", "text-sm");

    headings.forEach((heading, index) => {
      const id = heading.id || `heading-${index}`;
      heading.id = id;

      const tocItem = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${id}`;
      link.textContent = heading.textContent;
      link.classList.add("block");

      tocItem.setAttribute("data-name", id);
      tocItem.appendChild(link);
      tocList.appendChild(tocItem);
    });

    tocContainer.appendChild(tocList);

    const tocLinks = tocContainer.querySelectorAll("a");
    const visibilityObj = {};

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id;
          visibilityObj[id] = entry.isIntersecting;
        });

        for (let id in visibilityObj) {
          if (visibilityObj[id]) {
            tocLinks.forEach((link) => link.classList.remove("blog-active"));
            const activeLink = tocContainer.querySelector(`a[href="#${id}"]`);
            if (activeLink) activeLink.classList.add("blog-active");
            break;
          }
        }
      },
      { rootMargin: "-10% 0px -10% 0px", threshold: 0.1 }
    );

    headings.forEach((heading) => {
      observer.observe(heading);
      visibilityObj[heading.id] = false;
    });

    tocLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const id = this.getAttribute("href").substring(1);
        const targetElement = document.getElementById(id);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 10,
            behavior: "smooth",
          });
        }
      });
    });
  });


//mega-menu tabs
document.querySelectorAll('.mega-menu-tab').forEach(tabContainer => {
  const tabButtons = tabContainer.querySelectorAll('.mega-nav-tab-button');
  const tabContents = tabContainer.querySelectorAll('.mega-nav-tab-content');
  if (tabButtons.length && tabContents.length) {
    tabButtons[0].classList.add('active');
    tabContents[0].classList.add('active');
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      tabButtons.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      const tabId = button.getAttribute('data-tab');
      const targetContent = tabContainer.querySelector(`#${tabId}`);
      button.classList.add('active');
      if (targetContent) targetContent.classList.add('active');
    });
  });
});

//product-specsDrawer
  document.querySelectorAll('.product-specsWrapper').forEach(wrapper => { 
    const openBtn = wrapper.querySelector('.openProductPanel');
    const drawer = wrapper.querySelector('.product-specsDrawer');
    const panel = drawer.querySelector('.offcanvasProduct');
    const overlay = drawer.querySelector('.ProductOverlay');
    const closeBtns = drawer.querySelectorAll('.closeProductPanel');

    const openPanel = () => {
      panel.classList.add('open');
      overlay.classList.add('show');
      document.body.style.overflow = 'hidden';document.body.appendChild(drawer);
    };

    const closePanel = () => {
      panel.classList.remove('open');
      overlay.classList.remove('show');
      document.body.style.overflow = '';
    };

    openBtn.addEventListener('click', openPanel);
    closeBtns.forEach(btn => btn.addEventListener('click', closePanel));
    overlay.addEventListener('click', closePanel);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('open')) {
        closePanel();
      }
    });
  });
